module.exports = __webpack_public_path__ + "media/img/event/speakers/jamie-headshot-2ff5c4e8552963725875fa9b4b556256.jpg";